var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c("app-contact-search", {
            attrs: {
              value: _vm.value.Contact,
              "group-id": _vm.contactGroupId,
              fancy: "",
              label: _vm.$ct(
                "select-" + (_vm.contactGroupId == 2 ? "supplier" : "client")
              ),
              "show-supplier-switch": true,
            },
            on: {
              input: function ($event) {
                return _vm.onInput($event)
              },
              "update-group": function ($event) {
                _vm.contactGroupId = $event
              },
            },
          }),
          _vm.value.Contact && _vm.value.Contact.ID
            ? _c("div", { staticClass: "contact-details" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$ct(
                        _vm.contactGroupId == 2
                          ? "supplier-number"
                          : "client-number"
                      )
                    ) +
                      ": " +
                      _vm._s(_vm.value.Contact.ComputedFriendlyID)
                  ),
                ]),
                _vm.value.Contact.Vat
                  ? _c("span", [_vm._v(" | " + _vm._s(_vm.value.Contact.Vat))])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }